import React from "react"
import FormJournalEntry from "./Form";

export default function CreateJournalEntry() {
  return <FormJournalEntry />
}



// WEBPACK FOOTER //
// ./src/components/Accounting/JournalEntries/Create.js